import hashParams from './hashParams';
import MessageService from 'message-service/message-service';
import DistEvents from '@gameday/core/events/DistEvents';
import HashEvents from '@gameday/core/events/HashEvents';

const { UPDATE_TFS } = DistEvents;
const { GAME_ID_CHANGED } = HashEvents;

class HashState {
    constructor ({ game = null, timecode = null } = {}) {
        this.game = game;
        this.timecode = timecode;

        window.addEventListener('hashchange', () => {
            this.update(hashParams());
        });
    }

    update ({ game = this.game, timecode = this.timecode } = {}) {
        const { game: previousGame, timecode: previousTimecode } = this;
        this.game = game;
        this.timecode = timecode;

        if (game !== previousGame) {
            this.dispatchGame({ game, tfs: timecode });
        } else if (timecode !== previousTimecode) {
            this.dispatchTimecode(timecode);
        }
    }

    dispatchGame (payload) {
        MessageService.publish(GAME_ID_CHANGED, payload);
    }

    dispatchTimecode (timecode) {
        MessageService.publish(UPDATE_TFS, timecode);
    }
};

export default HashState;
